import { skillOptions } from "@rpforms/shared/build/constants";
import React from "react";
import Select from "react-select";

export const SkillSelect = ({ options, value, onChange, isDisabled = false }) => (
    <Select
        isMulti
        isDisabled={isDisabled}
        options={options}
        value={skillOptions(options, value)}
        onChange={(selected) => onChange((selected || []).map((option) => option.value))}
        placeholder="Skills auswählen..."
        noOptionsMessage={() => "Keine weiteren Skills"}
    />
);
